import { render, staticRenderFns } from "./packaging-template.vue?vue&type=template&id=3cf6d4c2"
import script from "./packaging-template.vue?vue&type=script&lang=js"
export * from "./packaging-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports